import {mergeTypeDefs, mergeResolvers} from "graphql-tools";
import {Kind} from "graphql";
import {pick, omit} from "lodash/object"
import getDataSchema from "./getDataSchema";
import {getDMMF} from "@prisma/sdk";
import path from "path";

export function importResolvers(resolvers, names: Array = []) {
    return pick(mergeResolvers(resolvers), names);
}

export function importResolversExcept(resolvers, names: Array = []) {
    return omit(mergeResolvers(resolvers), names);
}

export function importTypeDefs(defs, names: Array = [], exceptMode = false) {
    let res = {...defs, definitions: defs.definitions.filter(d => !d.name)};
    const pulledDefinitions = [];
    const extractType = type => type.type?.type?.type || type.type?.type || type.type || type;
    const puller = name => {
        if (!name || pulledDefinitions.find(pd => pd.name?.value === name)) return;
        const path = name.split('.');
        let target = defs.definitions.find(d => d.name?.value === path[0]);
        if (target) {
            target = path[1] ? {...target, fields: target.fields.filter(d => d.name.value === path[1])} : target;
            pulledDefinitions.push(target);
            target.fields?.forEach(f => {
                if (extractType(f.type).kind === Kind.NAMED_TYPE) {
                    puller(extractType(f.type).name.value)
                }
                f.arguments?.forEach(arg => {
                    if (extractType(arg.type).kind === Kind.NAMED_TYPE) {
                        puller(extractType(arg.type).name.value)
                    }
                })
            })
            res = mergeTypeDefs([res, {kind: 'Document', definitions: pulledDefinitions}]);
        }
    };
    const targetNames = exceptMode
        ? defs.definitions.filter(d => d.name && !names.includes(d.name.value)).map(d => d.name.value)
        : names;
    targetNames.forEach(puller)
    return res;
}

export function importResolversFor(resolvers, typeDefs) {
    const resolverNames = [];
    typeDefs.definitions.forEach(d => {
        if (d.name?.value && d.kind !== Kind.INPUT_OBJECT_TYPE_DEFINITION) {
            d.fields?.forEach(f => {
                resolverNames.push(`${d.name.value}.${f.name.value}`);
            })
        }
    })
    return importResolvers(resolvers, resolverNames)
}

export function importFrom({typeDefs, resolvers}, names) {
    const tds = importTypeDefs(typeDefs, names);
    return {typeDefs: tds, resolvers: importResolversFor(resolvers, tds)}
}


export function importFromExcept({typeDefs, resolvers}, names) {
    const tds = importTypeDefs(typeDefs, names, true);
    return {typeDefs: tds, resolvers: importResolversFor(resolvers, tds)}
}

export function modelSelection(modelName) {
    const datamodel = require(path.join(process.cwd(), '.easy-gql', 'datamodel.json'));
    const fields = datamodel.datamodel.models.find(m => m.name === modelName)?.fields.filter(f => f.kind !== 'object').map(({name}) => name);
    return fields && Object.fromEntries(fields.map(f => [f, true]))
}
